(function () {
    const INIT_FLAG = "mbAccordionInit"; // dataset flag name

    function setOpen(rootEl, key, open) {
        const toggle = rootEl.querySelector(
            `[data-accordion-toggle="${CSS.escape(key)}"]`
        );
        const panel = rootEl.querySelector(
            `[data-accordion-panel="${CSS.escape(key)}"]`
        );
        if (!toggle || !panel) return;

        toggle.setAttribute("aria-expanded", open ? "true" : "false");
        panel.hidden = !open;
    }

    function initAccordion(rootEl) {
        // ✅ Prevent double-init on the same root element
        if (rootEl.dataset[INIT_FLAG] === "1") return;
        rootEl.dataset[INIT_FLAG] = "1";

        rootEl.querySelectorAll("[data-accordion-toggle]").forEach((toggle) => {
            const key = toggle.dataset.accordionToggle;
            const open = toggle.getAttribute("aria-expanded") === "true";
            setOpen(rootEl, key, open);
        });

        rootEl.addEventListener("click", (e) => {
            const toggle = e.target.closest("[data-accordion-toggle]");
            if (!toggle || !rootEl.contains(toggle)) return;

            const key = toggle.dataset.accordionToggle;
            const isOpen = toggle.getAttribute("aria-expanded") === "true";
            setOpen(rootEl, key, !isOpen);
        });
    }

    function initAll(root) {
        root.querySelectorAll("[data-mb-accordion]").forEach(initAccordion);
    }

    document.addEventListener("DOMContentLoaded", () => initAll(document));
    document.addEventListener("shopify:section:load", (e) => initAll(e.target));
})();
